export default function OrtTile({data}) {
    return <a href={data.permalink} className="ort-tile teaserColumns__item bottom">
        <div className="ort-tile__image-wrapper">
            <img className="ort-tile__img" src={data.thumbnail} alt={data.title} />
            <div className="ort-tile__icon-overlay">
                {window.baukulturMap.getIcons(data.ort_type).map(icon => <img className="ort-tile__icon" src={icon[1]} alt={icon[0]} title={icon[0]} key={icon[0]} />)}
            </div>
        </div>
        <div className="teaserColumns__contentWrapper">
            <div className="teaserColumns__text font-base">
                <div className="ort-tile__location teaserColumns__date">{data.ort_location}</div>
                <h4 className="teaserColumns__title font-h4">{data.title}</h4>
                <p>{data.ort_shorttext}</p>
            </div>
        </div>
        <span className="teaserColumns__button bottom">mehr</span>
    </a>
}
